var map = {
	"./bg": 118,
	"./bg.jpeg": 118,
	"./bg@2x": 119,
	"./bg@2x.jpeg": 119,
	"./salon": 120,
	"./salon.jpeg": 120,
	"./summer": 121,
	"./summer.jpg": 121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;